import {ButtonMenu as PeacockButtonMenu} from '@pepsico-ds/ui'

/**
 * @typedef {import('@pepsico-ds/ui').IButtonMenuProps} ButtonMenuProps
 * @property {boolean} [showSearch] When true, shows the search input in the menu. Defaults to false.
 * @property {boolean} [disabled] When true, the button menu is disabled.
 * @property {import('@pepsico-ds/ui').IMenuListItem[]} options Menu options.
 * @property {import('@pepsico-ds/ui').IMenuListItem} [value] Selected menu option.
 * @property {(value: {id: string, label: string} | undefined) => void} [onChange] Callback when a menu option is selected.
 * @property {import('@pepsico-ds/ui').IButtonProps} buttonProps Props for the trigger button.
 * @property {'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'} [menuPosition] Menu position. Defaults to 'bottom-right'.
 * @property {boolean} [usePortal] When true, renders the menu in a portal to avoid clipping. Defaults to false.
 * @property {string} ['data-cy'] Optional Cypress test attribute.
 */

/**
 * Wrapper around Peacock DS ButtonMenu.
 * Supports all Peacock DS button menu props.
 * @param {ButtonMenuProps} props
 */
export const ButtonMenu = props => {
  return <PeacockButtonMenu {...props} />
}
